import { Component, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

type symbolType = '-' | '+';

@Component({
    selector: 'app-more-details',
    templateUrl: './more-details.component.html',
    styleUrls: ['./more-details.component.scss'],
    standalone: true,
    imports: [MatButtonModule]
})
export class MoreDetailsComponent {

  @Output() needOpen = new EventEmitter<boolean>();

  isOpened = false;
  symbol: symbolType = '+';

  onClick() {
    this.isOpened = !this.isOpened;
    if(this.isOpened) {
      this.symbol = '-';
    } else {
      this.symbol = '+';
    }

    this.needOpen.next(this.isOpened);
  }
}
